export const getQueryParams = (queryString) => {
  if (!queryString) {
    return {};
  }
  const params = queryString.replace('?', '').replace(/#.*/, '').split('&');
  const paramMap = {};
  params.forEach((param) => {
    const [key, value = true] = param.split('=');
    paramMap[key] = value;
  });
  return paramMap;
};
